module.exports = __webpack_public_path__ + "img/8139AE53-2A29-4408-B6E7-1EBF6119E303.e3866123.png";